<template>
  <div v-loading="loading">
    <div class="boxChat-detail">
      <div v-if="isPopupChat" class="header d-flex align-items-center justify-content-between bgX pd10" style="padding-left: 10px !important; border-radius: 10px 10px 0 0">
        <div class="d-flex align-items-center">
          <div @click="backListChat()" class="cursor">
            <img src="@/static/icon/chat/left.svg" alt="">
          </div>
          <div class="avatar-ncc ml-1">
            <img src="@/static/icon/chat/noa.png" alt="">
          </div>
          <div class="d-flex flex-column">
            <div class="d-flex flex-column"  v-if="isXNK" style="font-weight: 700">
              <span class="name">{{ infoDetail.user_name }}</span>
              <div class="d-flex align-items-center py-1" style="font-size: 12px">
                <span>KH: {{ infoDetail.customer_name }} - {{ infoDetail.customer_phone }}</span>
              </div>
              <div class="name mBg">MBG: {{ infoDetail.quote_code }}</div>
            </div>
            <span v-else class="name">MBG: {{ infoDetail.quote_code }}</span>
          </div>
        </div>
        <div>
          <img @click="zoomPopup()" class="cursor" src="@/static/icon/chat/vector.svg" alt="">
        </div>
      </div>
      <div v-else class="header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <div class="avatar-ncc">
            <img src="@/static/icon/chat/noa.png" alt="">
          </div>
          <div>
            <span v-if="isXNK" class="name">{{ infoDetail.user_name }} - {{ infoDetail.customer_name }} - {{ infoDetail.customer_phone }}</span>
            <el-link
              style="font-size: 12px"
              :href="$router.resolve({ name: 'quote-update', params: { quote_id: infoDetail.quote_id } }).href"
              target="_blank"
              v-else
              class="name"
            >
              <span >MBG: {{ infoDetail.quote_code }}</span>
            </el-link>
          </div>
        </div>
        <div v-if="isXNK" style="background: #0C91DF; color: #ffffff; padding: 5px; border-radius: 5px">
          <el-link
            style="font-size: 12px; color: #ffffff"
            :href="$router.resolve({ name: 'quote-update', params: { quote_id: infoDetail.quote_id } }).href"
            target="_blank"
            class="name"
          >
            <span >MBG: {{ infoDetail.quote_code }}</span>
          </el-link>
        </div>
      </div>
    </div>
    <!--    -->
    <div class="boxChat-detail fullwidth-box-detail" ref="chatBox" :class="getChatBoxClass()">
      <div class="body-detail" :class="isPopupChat ? 'ml10' : ''">
        <div v-if="hasMore" style="text-align: center; cursor: pointer; font-size: 12px" @click="moreChat()">
          <span>Xem thêm lịch sử chat</span>
        </div>
        <!--        -->
        <div v-for="(item, index) in listMessage" :key="item.id">

          <div v-if="isNewDay(index)" class="date-separator">
            {{ formatDateLabel(item.time) }}
          </div>
          <!-- MESSAGE -->
          <div class="d-flex" style="padding: 2px 0" :class="isYourMessage(item) ? 'content-end' : ''">
            <div v-if="!isYourMessage(item)">
              <div v-if="isFirstMessageFromSource(item.user_name, index)">
                <img v-if="infoDetail.customer_image" :src="infoDetail.customer_image" alt="" class="face">
                <img v-else src="@/static/icon/chat/noa.png" alt="" class="face">
              </div>
              <div class="face" v-else></div>
            </div>
            <!--            -->
            <div class="content-txt" :class="!isYourMessage(item) ? 'bg-user' : 'bg-customer'">
              <el-popover
                placement="right"
                width="60"
                trigger="hover"
              >
                <!--                  // option message-->
                <div class="d-flex flex-column menu-chat" style="text-align: left; cursor: pointer">
                  <span @click="replyToMessage(item)">Phản hồi</span>
                  <span v-if="isYourMessage(item)" @click="editToMessage(item)" style="padding-top: 10px">Chỉnh sửa</span>
                  <span v-if="isYourMessage(item)" @click="recallToMessage(item)" style="padding-top: 10px">Gỡ</span>
                </div>

                <div slot="reference">
                  <div v-if="isFirstMessageFromSource(item.user_name, index)" :class="isYourMessage(item) ? 'text-right' : ''" style="font-size: 12px; font-weight: 700; padding-bottom: 5px; color: #f7941d">
                    <span>{{ item.user_name }}</span>
                  </div>
                  <!--                    phần hiện thị tin nhắn rep-->
                  <div class="box-mess-rep" v-if="item.reply_id != 0">
                    <div class="pb-2">
                      <span v-if="item.user_name_parent">{{ item.user_name_parent }}</span>
                    </div>
                    <div v-if="item.type_parent == 0" class="truncate-text">{{ item.content_parent }}</div>
                    <div v-if="item.type_parent == 1" class="d-flex">
                      <img style="width: 30px; height: 30px" :src="parseJson(item.content_parent).full_path" alt="">
                      <span class="pt-1 pl-1">Ảnh</span>
                    </div>
                    <div v-if="item.type_parent == 2" class="d-flex">
                      <video style="width: 30px; height: 30px" class="boxfile" controls="controls">
                        <source :src="parseJson(item.content_parent).full_path" />
                      </video>
                      <span class="pt-1 pl-1">Video</span>
                    </div>
                    <div v-if="item.type_parent == 3" class="d-flex">
                      <img style="width: 30px; height: 30px" src="@/static/icon/chat/pdf.png" alt="" >
                      <span class="pt-1 pl-1">{{ parseJson(item.content_parent).name_origin }}</span>
                    </div>
                  </div>


                  <div class="d-flex align-items-center" :class="isYourMessage(item) ? 'justify-content-end' : ''">
                    <!-- message là  text-->
                    <div class="textType1" v-if="item.type == 0">{{ item.content }}</div>
                    <!-- message là  ảnh-->
                    <div>
<!--                      <img @click="zoomContent(parseJson(item.content))" class="boxfile" v-if="item.type == 1" :src="parseJson(item.content).full_path" alt="">-->
                      <el-image
                        class="mImage"
                        v-if="item.type == 1"
                        style="width: 150px; height: 150px;"
                        :src="parseJson(item.content).full_path"
                        :preview-src-list="[parseJson(item.content).full_path]">
                      </el-image>
                      <video  class="boxfile" controls="controls" v-if="item.type == 2">
                        <source :src="parseJson(item.content).full_path" />
                      </video>
                      <!-- message là  file-->
                      <div v-if="item.type == 3">
                        <a :href="parseJson(item.content).full_path" target="_blank"><img src="@/static/icon/chat/pdf.png" alt="" style="width: 30px; height: 30px" ></a>
                        <p>{{ parseJson(item.content).name_origin }}</p>
                      </div>
                      <div class="pt-1" v-if="parseJson(item.content) && parseJson(item.content).caption" :class="!isYourMessage(item) ? 'txtL' : 'txtR'">
                        <span>{{ parseJson(item.content).caption }}</span>
                      </div>
                    </div>
                    <!-- message là sản phẩm-->
                    <div class="d-flex" v-if="item.type == 4">
                      <img v-if="parseJson(item.content) && parseJson(item.content).image" :src="parseJson(item.content).image" alt="" style="width: 80px; height: 80px; object-fit: cover">
                      <img v-else src="@/static/icon/chat/no-image.png" alt="" style="width: 80px; height: 80px; object-fit: cover">
                      <div class="pl-2" style="font-size: 12px">
                        <span>{{ parseJson(item.content).name_des}}</span>
                        <p>{{ parseJson(item.content).quantity | vnd2 }} sản phẩm</p>
                        <p>{{ parseJson(item.content).price | vnd }}</p>
                      </div>
                    </div>

                  </div>

                  <div class="d-flex justify-content-end time-style">
                    <span>{{ item.time | vnTimeAgo }}</span>
                  </div>

                </div>

              </el-popover>
            </div>
            <!--      -->
            <div v-if="isYourMessage(item)" class="pl-2">
              <div v-if="isFirstMessageFromSource(item.user_name, index)">
                <img v-if="infoDetail.user_image" :src="infoDetail.user_image" alt="" class="face">
                <img v-else style="background: #000935" src="@/static/icon/header-top/account.svg" alt="" class="face">
              </div>
              <div v-else class="face"></div>
            </div>
          </div>
        </div>

        </div>
    </div>
    <!--    -->

    <!--    // phần sản phảm popup-->
    <div v-if="isPopupChat">
      <ProductScroll :infoDetail="infoDetail"></ProductScroll>
    </div>

    <div class="rep-bottom">
      <div class="d-flex align-items-center justify-content-between boxRep" v-if="isReply || isEditM">
        <div class="d-flex align-items-center">
          <div class="pr-2">
            <img  v-if="isReply" style="width: 20px; height: 20px" src="@/static/icon/chat/rep.png" alt="">
            <img v-if="isEditM" style="width: 20px; height: 20px" src="@/static/icon/chat/pen.png" alt="">
          </div>
          <div>
            <div class="d-flex align-items-center head-rep" v-if="isReply">
              <span class="pr-1">Reply to</span>
              <span>{{ messageToReply.user_name }}</span>
            </div>
            <div class="d-flex align-items-center head-rep" v-if="isEditM">
              <span class="pr-1">Chỉnh sửa tin nhắn</span>
            </div>
            <div class="content-rep">
              <div class="truncate-text" v-if="contentReply.type == 0">{{ contentReply.content }}</div>
              <div v-if="contentReply.type == 1" class="d-flex align-items-center">
                <img :src="parseJson(contentReply.content).full_path" alt="" style="width: 40px; height: 40px">
                <span class="pl-1">Ảnh</span>
              </div>
              <div v-if="contentReply.type == 2" class="d-flex align-items-center">
                <video style="width: 40px; height: 40px" class="boxfile" controls="controls">
                  <source :src="parseJson(contentReply.content).full_path" />
                </video>
                <span class="pl-1">Video</span>
              </div>
              <div v-if="contentReply.type == 3" class="d-flex">
                <img style="width: 40px; height: 40px" src="@/static/images/chat/pdf.png" alt="" >
                <span class="pt-1 pl-1">{{ parseJson(contentReply.content).name_origin }}</span>
              </div>
              <div v-if="contentReply.type == 4" class="d-flex align-items-center">
                <img :src="parseJson(contentReply.content).image" alt="" v-if="parseJson(contentReply.content).image" style="width: 40px; height: 40px" />
                <img src="@/static/icon/chat/no-image.png" style="width: 30px; height: 30px" alt="" v-else/>
                <span class="pl-1">Sản phẩm</span>
              </div>
            </div>
          </div>
        </div>
        <div style="cursor: pointer">
          <span @click="cancelMenuChat()"><i class="el-icon-close"></i></span>
        </div>
      </div>
      <div class="line-send-chat" :class="isPopupChat ? 'bgX ml10' : ''">
        <div class="input-chat">
          <el-input
            :class="isPopupChat ? 'bgX' : ''"
            ref="chatInput"
            type="textarea"
            :rows="2"
            v-model="content"
            placeholder="Nhập tin nhắn mới"
            @keydown.native="handleKeydown"
          ></el-input>
        </div>
        <div class="d-flex align-items-center justify-content-end pt-1">
          <i v-if="loadingFile" class="el-icon-loading"></i>
          <img v-else @click="selectFilechat()" src="@/static/icon/chat/file2.svg" alt="" class="action">
          <emoji class="ml-2" :addEmojiToMessage="addEmojiToMessageContent" />
          <img @click="isEditM ? submitEditMessage(0) : storeMessage(0)" src="@/static/icon/chat/send.svg" alt="" class="action">
        </div>
      </div>
    </div>


    <input
      style="display: none"
      type="file"
      class="upload-avatar"
      id="fileChat"
      ref="fileChat"
      v-on:change="handleFileUploadChat()"
    />

    <el-dialog :visible.sync="dialogVisibleZoom" class="imageZom" :append-to-body="true">
      <img
        width="100%"
        :src="objZoom"
      />
    </el-dialog>

    <!--  // phần pop-up khi gửi file  -->
    <el-dialog :visible.sync="dialogSendFile" :append-to-body="true" class="file-upload-send" title="Gửi file"  width="30%">
      <div class="d-flex align-items-center">
        <div v-if="typeFileUpload == 1">
          <img :src="objFile.full_path" alt="" style="width: 60px; height: 60px; object-fit: cover; border-radius: 5px">
        </div>
        <div v-if="typeFileUpload == 2">
          <video style="width: 60px; height: 60px" controls="controls">
            <source :src="objFile.full_path" />
          </video>
        </div>
        <div v-if="typeFileUpload == 3" class="d-flex align-items-center">
          <img style="width: 60px; height: 60px; border-radius: 5px" src="@/static/icon/chat/pdf.png" alt="" >
        </div>
        <div>
          <span class="pt-1 pl-1">{{ objFile.name_origin }}</span>
        </div>
      </div>
      <div style="padding-top: 10px">
        <span style="padding-bottom: 5px; font-size: 13px; color: #1d60a6" >Caption</span>
        <el-input ref="chatCaption" @keyup.enter.native="sendUploadFile()" class="inputCaption" v-model="caption"></el-input>
      </div>
      <div class="d-flex align-items-center justify-content-end pt-3">
        <el-button type="info" @click="dialogSendFile = false" size="mini">Trở về</el-button>
        <el-button type="primary" size="mini" @click="sendUploadFile()">Gửi</el-button>
      </div>
    </el-dialog>



  </div>
</template>

<script>
  import ProductScroll from "@/views/chat/components/ProductScroll";
  import EventBus from "@/EventBus";
  import axios from "axios";
  import Emoji from "./Emoji";
  import {mapGetters} from "vuex";
  import {getToken} from "@/views/account/store/auth";
  import store from "@/store";
  export default {
    name: "DetailChat",
    metaInfo() {
      return {
        title: "",
      };
    },
    props: {
      infoDetail: Object,
    },
    components: {
      Emoji,
      ProductScroll
    },
    data() {
      return {
        canSubmit: true,
        loading: false,
        hasMore: true,
        showButton: false,
        dialogVisibleZoom: false,
        loadingFile: false,

        content: "",
        filter: {
          page: 1,
          per_page: 20,
        },
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          last_page: 0,
        },
        listMessage: [],
        scrollY: 0,
        checkMore: false,

        objZoom: {},


        // rep từng tin nhắn
        messageToReply: null,
        isReply: false,
        contentReply: {},

        // chỉnh sửa tin nhắn
        isEditM: false,

        dialogSendFile: false,
        objFile: {},
        caption: "",
        typeFileUpload: 0,
        isEditUploadFile: false,
        isSending: false,

        // phần copy ảnh rồi dán
        checkCopyfile: false,
        fileCopy: null,
      };
    },
    computed: {
      ...mapGetters(["path", "full_path"]),
      ...mapGetters("account", ["accountInfo", "language"]),
      isPopupChat () {
        return this.path !== 'chat-list'
      },
      isXNK () {
        return this.accountInfo.roles[0].description == 'XNK';
      },

    },
    mounted() {
      EventBus.$on('messageProduct', this.storeMessageProduct);
    },
    methods: {
      parseDate(time) {
        return new Date(time.replace(' ', 'T'))
      },
      isNewDay(index) {
        if (index === 0) return true
        const prev = this.parseDate(this.listMessage[index - 1].time)
        const cur = this.parseDate(this.listMessage[index].time)
        return (
          prev.getFullYear() !== cur.getFullYear() ||
          prev.getMonth() !== cur.getMonth() ||
          prev.getDate() !== cur.getDate()
        )
      },
      formatDateLabel(time) {
        const d = this.parseDate(time)
        return d.toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric'
        })
      },
      // tin nhắn prodcut
      storeMessageProduct (val) {
        this.content = JSON.stringify(val);
        this.storeMessage(4);
      },
      // phần thu hồi tin nhắn
      recallToMessage (val) {
        const index = this.listMessage.findIndex(item => item.id === val.id)
        if (index !== -1) {
          this.listMessage.splice(index, 1)
        }
        axios.delete("chat/" + val.id).then((response) => {
          switch (response.code) {
            case 200:
              break;
            case 422:
              this.$notify({
                title: "Có lỗi xảy ra",
                message: Object.values(response.data)[0],
                type: "warning",
              });
              break;
            default:
              this.fetchMessage();
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        });
      },
      // phần sửa tin nhắn
      editToMessage (message) {
        this.messageToReply = message;
        if (this.messageToReply) {
          this.contentReply = this.messageToReply
          this.isEditM = true;
          this.isReply = false;
          if (this.contentReply.type == 0) {
            this.content = this.contentReply.content;
          }
          if (this.contentReply.type == 1 || this.contentReply.type == 2 || this.contentReply.type == 3) {
            this.content = this.parseJson(this.contentReply.content).caption;
          }
          this.$refs.chatInput.focus();
          const target = document.getElementById('lineChatBt');
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      },
      submitEditMessage (type) {
        if (this.content.trim() === '') {
          return;
        }
        if (this.content.length >= 500) {
          this.$notify({
            title: "Cảnh báo",
            message: "Nội dung tin nhắn không được quán 500 ký tự.",
            type: "warning",
          });
          return;
        }
        // chỉnh sửa caption file
        if (this.contentReply.type == 1 || this.contentReply.type == 2 || this.contentReply.type == 3) {
          let  objJson = {};
          objJson = this.parseJson(this.contentReply.content);
          objJson.caption = this.content;
          this.content =  JSON.stringify(objJson);
          type = this.contentReply.type;
        }
        let data = {
          content: this.content,
          type: type,
        }
        // Đẩy realtime socket
        // Đẩy luôn lên hội thoại ko load lại data

        this.listMessage.forEach((item) => {
          if (item.id == this.contentReply.id) {
            item.content = this.content;
            item.type = type
          }
        })


        this.$socket.emit("edit-message-to-conversation", {
          'content': this.content,
          'from': 'admin',
          'type': type,
          'message_id': this.contentReply.id,
          'customer_code': this.infoDetail.customer_code,
        });

        this.content = '';
        this.isReply = false;
        this.isEditM = false;
        this.isEditUploadFile = false;
        this.messageToReply = null;
        this.scrollToBottom();
        console.log(this.contentReply, 'this.contentReply')
        axios.put("chat/" + this.contentReply.id, data).then((response) => {
          switch (response.code) {
            case 200:
              this.contentReply = null;
              break;
            case 422:
              this.$notify({
                title: "Có lỗi xảy ra",
                message: Object.values(response.data)[0],
                type: "warning",
              });
              break;
            default:
              this.fetchMessage();
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        });
      },

      // phần rep tin nhắn
      replyToMessage(message) {
        this.messageToReply = message;
        if (this.messageToReply) {
          this.contentReply = this.messageToReply
          this.isReply = true;
          this.isEditM = false;
          this.$refs.chatInput.focus();
        }
      },
      // phần đóng khi sửa hoặc rep
      cancelMenuChat () {
        this.isReply = false;
        this.isEditM = false;
        this.isEditUploadFile = false;
      },
      isYourMessage(item) {
        return this.accountInfo.name == item.user_name;
      },
      // ấn Enter chat
      handleKeydown(event) {
        // Kiểm tra xem có phải Ctrl + Enter không
        if (event.key === "Enter" && event.ctrlKey) {
          event.preventDefault(); // Ngăn chặn hành động mặc định của Enter
          this.insertNewLine(); // Thực hiện hành động thay thế (thêm dòng mới)
        } else if (event.key === "Enter") {
          event.preventDefault(); // Ngăn chặn gửi tin nhắn khi nhấn Enter một mình
          if (this.isEditM) {
            this.submitEditMessage(0)
          } else {
            this.storeMessage(0); // Gửi tin nhắn
          }
        }
      },
      insertNewLine() {
        this.content += "\n";
      },
      storeMessage (type) {
        let user_name_check = this.accountInfo.name
        if (this.content.trim() === '') {
          return;
        }
        if (this.content.length >= 500) {
          this.$notify({
            title: "Cảnh báo",
            message: "Nội dung tin nhắn không được quán 500 ký tự.",
            type: "warning",
          });
          return;
        }
        let data = {
          type: type,
          content: this.content,
          quote_id: this.infoDetail.quote_id
        }

        if (this.isReply) {
          data.reply_id = this.contentReply.id
        }

        // Đẩy realtime
        // let parentReal = null
        // if (this.isReply) {
        //   parentReal = {
        //     user_name: this.contentReply.user_name,
        //     type: this.contentReply.type,
        //     content: this.contentReply.content
        //   }
        // }

        // Đẩy luôn lên hội thoại ko load lại data

        let obj = {};
        let currentTime = '';
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
        currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        let idMake = Math.floor(Math.random() * 100000) + 1;
        obj = {
          id: idMake,
          content: this.content,
          type: type,
          time: currentTime,
          reply_id: 0,
          seen: false,
          user_name: user_name_check,
          content_parent: null,
          type_parent: null,
          user_name_parent: null
        }
        if (this.isReply) {
          obj.reply_id = this.contentReply.id;
          obj.content_parent = this.contentReply.content;
          obj.type_parent = this.contentReply.type;
          obj.user_name_parent = this.contentReply.user_name;
        }
        this.listMessage.push(obj);

        let contentCheck = ""
        if (type == 1) {
          contentCheck = user_name_check  + " đã gửi 1 ảnh"
        }
        else if (type == 2) {
          contentCheck = user_name_check  + " đã gửi 1 video"
        }
        else if (type == 3) {
          contentCheck = user_name_check  + " đã gửi 1 file"
        }
        else if (type == 4) {
          contentCheck = user_name_check  + " đã gửi 1 sản phẩm"
        }
        else {
          contentCheck = this.content
        }

        let objLast = {
          id: this.infoDetail.id,
          content:  contentCheck,
          time_sent: currentTime,
        };
        this.$emit('dataLast', objLast);

        // Bổ sung của phần realtime sau khi bắn api
        // let parent_id = this.isReply ? Math.floor(Math.random() * 100000) + 1 : 0;

        this.content = '';
        this.isReply = false;
        this.contentReply = null;
        this.messageToReply = null;
        this.scrollToBottom();

        axios.post("chat", data).then((response) => {
          switch (response.code) {
            case 200:
              var data = response.data;
              var message = data.message;
              var listUserCode = data.list_user_code;
              this.$socket.emit("sent-message-to-conversation", {
                'arr_user_code': listUserCode,
                'message': message,
              });

              // Check lại cái tin nhắn đẩy luôn để update lại ID gốc
              this.listMessage.forEach((item) => {
                if (item.id == idMake) {
                  item.id = message.id;
                }
              })

              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        });
      },

      // them emoji
      addEmojiToMessageContent(value) {
        this.content += value;
        this.focusInput();
      },
      // xem them chat
      moreChat() {
        this.filter.page++;
        this.checkMore = true
        this.fetchMessage();
      },
      fetchMessage () {
        let filter = {
          page: this.filter.page,
          per_page: this.filter.per_page,
        }
        this.loading = true;
        this.hasMore = true;
        let dataItem = {};
        axios.get("chat/" + this.infoDetail.id, {params: filter}).then((response) => {
          this.loading = false
          switch (response.code) {
            case 200:
              dataItem = response.data.items;
              dataItem = dataItem.filter(item => item.content)
              dataItem.map(function (i) {
                i.seen = true;
                return i;
              });
              dataItem = JSON.parse(JSON.stringify(dataItem));
              if (!this.checkMore) {
                this.listMessage.unshift(...dataItem);
                this.listMessage.reverse();
                this.scrollToBottom();
              } else {
                this.listMessage.unshift(...dataItem.reverse());
              }
              this.checkMore = false;
              // this.scrollToBottom();
              if (dataItem.length < this.filter.per_page) {
                this.hasMore = false;
              }
              this.$refs.chatInput.focus();
              // check tin nhắn đọc hay chưa
              // this.checkSeenMessage();
              this.fetchCountUnseenMessage();
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        });
      },
      checkSeenMessage () {
        let num_not_seen = this.boxActive.unread_client;
        if (num_not_seen > 0) {
          const lastThreeRecords = this.listMessage.slice(-num_not_seen);
          lastThreeRecords.forEach(record => {
            record.seen = false;
          });
        }
      },
      focusInput() {
        this.$refs.chatInput.focus();
      },
      scrollToBottom() {
        this.$nextTick(() => {
          const chatBox = this.$refs.chatBox;
          if (!chatBox) return;
          chatBox.scrollTop = chatBox.scrollHeight;
        });
      },
      isFirstMessageFromSource (user_name, index) {
        // Kiểm tra xem đây có phải là tin nhắn đầu tiên từ nguồn này không
        return index === 0 || this.listMessage[index - 1].user_name !== user_name;
      },
      getChatBoxClass() {
        return {
          'box-width-is-rep': this.isReply || this.isEditM,
          'fullwidth-box-detail-popup': this.isPopupChat,
          'box-width-is-rep-popup': (this.isReply || this.isEditM) && this.isPopupChat,
        }
      },
      // phần up ảnh video
      selectFilechat () {
        document.getElementById("fileChat").click();
      },
      handleFileUploadChat () {
        this.typeFileUpload = 0;
        this.objFile = {};
        this.isEditUploadFile = false;
        this.file = this.$refs.fileChat.files[0];
        if (this.checkCopyfile) {
          // phần file copy
          this.file = this.fileCopy;
        }
        let file = this.file;
        const isLt8M = file.size / 1024 / 1024 < 8;

        if (!isLt8M) {
          this.$message.error("Dung lượng file tối đa là 8M");
          return;
        }
        let typeFile = file["type"];
        let arr_type = [
          "image/jpeg",
          "image/png",
          "image/jpg",
          "video/avi",
          "video/flv",
          "video/wmv",
          "video/mov",
          "video/mp4",
          "video/avchd",
          "video/webm",
          "video/mkv",
          "video/quicktime",
          "application/pdf",
          "application/msword", // Allow Word .doc files
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ];
        if (!arr_type.includes(typeFile)) {
          this.$message.error("Chỉ được upload file ảnh, video, word, pdf");
          return;
        }
        this.submitFile();
      },
      async submitFile() {
        let formData = new FormData();
        formData.append("files[]", this.file);
        formData.append("model", 'quote-comment');
        this.loadingFile = true;
        fetch(process.env.VUE_APP_API_URL + "media/upload", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
          body: formData,
        })
          .then((response) => response.json())
          .then((result) => {
            this.loadingFile = false;
            let url = result.data[0].full_path;
            const fileExtension = url.split('.').pop().toLowerCase();
            if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(fileExtension)) {
              this.typeFileUpload = 1;
            } else if (['mp4', 'mov', 'avi', 'mkv', 'webm', 'quicktime'].includes(fileExtension)) {
              this.typeFileUpload = 2;
            } else if (fileExtension === 'pdf') {
              this.typeFileUpload = 3;
            } else if (['doc', 'docx'].includes(fileExtension)) {
              this.typeFileUpload = 3;
            }
            this.objFile = result.data[0];
            this.caption = '';
            this.dialogSendFile = true;
            this.checkCopyfile = false;
            if (this.isEditM) {
              this.isEditUploadFile = true;
            }
            setTimeout(() => {
              this.$refs.chatCaption.focus();
            }, 1000);
          })
          .catch(() => {
            this.loadingFile = false;
            this.checkCopyfile = false;
            this.$notify.error({
              title: "Error",
              message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
            });
          });
      },
      sendUploadFile () {
        this.$refs.chatCaption.blur()
        let objdata = {}
        objdata = this.objFile;
        objdata.caption = this.caption;
        if (this.isEditUploadFile) {
          this.contentReply.content = objdata;
          this.content = this.caption;
          this.submitEditMessage(this.typeFileUpload)
        } else {
          this.content = JSON.stringify(objdata);
          this.storeMessage(this.typeFileUpload); // Gửi tin nhắn
        }
        this.dialogSendFile = false;
      },
      parseJson(jsonString) {
        try {
          return JSON.parse(jsonString);
        } catch (e) {
          return jsonString;
        }
      },
      zoomContent (value) {
        this.objZoom = value.full_path
        this.dialogVisibleZoom = true;
      },




      // trở về ds chat popup
      backListChat () {
        this.$emit('backListChat', true);
      },
      zoomPopup () {
        // EventBus.$emit('zoomPopupChat', true);
        let obj = {
          event: 'detailChatList',
          chat_id: this.infoDetail.id
        }
        EventBus.$emit('zoomPopupChat', obj);

      },
      fetchCountUnseenMessage() {
        axios.get("chat/count/unseen").then((response) => {
          switch (response.code) {
            case 200:
              store.dispatch("setTotalUnseenMessage", response.data);
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        });
      },

      formatDateTime(time = new Date()) {
        const d = new Date(time);

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },

    },
    watch: {
      infoDetail: {
        immediate: true,
        handler(val) {
          if (!val) return
          this.listMessage = [];
          this.filter.page = 1;
          this.isEditM = false;
          this.isReply = false;
          this.content = "";
          this.fetchMessage();
        }
      }
    },
    sockets: {
      "receive-message-to-conversation": function (data) {
        if(data) {
          console.log(data);
          let  dataM = data.message
          let obj = {
            id: dataM.id,
            content: dataM.content,
            type: dataM.type,
            time: this.formatDateTime(dataM.created_at),
            reply_id: dataM.reply_id,
            seen: false,
            user_name: dataM.user_name,
            content_parent: dataM.content_parent,
            type_parent: dataM.type_parent,
            user_name_parent: dataM.user_name_parent,
          }
          this.listMessage.push(obj);
          this.scrollToBottom();
        }
      },
    }
  };
</script>

<style lang="css" scoped>
  .boxfile {
    width: 100px;
    height: 100px;
    object-fit: contain;
  }
  .status_order {
    padding: 2px 5px;
    font-size: 11px;
    color: #ffffff;
    margin-left: 5px;
    border-radius: 4px;
  }
  .body-detail {
    padding-top: 20px;
  }
  .on {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #07AF0E;
  }

  .body-detail .face {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 8px;
    object-fit: cover;
  }

  .body-detail .content-txt {
    padding: 10px;
    border-radius: 20px;
  }

  .boxChat-detail .header {
    border-bottom: 1px solid #C4C4C440;
    padding: 10px 20px 10px 0;
  }

  .boxChat-detail .header .avatar-ncc img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 10px;
    object-fit: cover;
  }

  .boxChat-detail .header .name-ncc {
    font-size: 12px;
    font-weight: 700;
  }

  .boxChat-detail .header .code-po {
    padding: 2px 5px;
    background: #399CFF;
    color: #ffffff;
    border-radius: 4px;
    margin-right: 5px;
    font-size: 11px;
    cursor: pointer;
  }

  .line-send-chat {
    padding: 10px;
    border: 1px solid #F0EFEF;
    border-radius: 16px;
    margin-bottom: 10px;
  }
  .line-send-chat .action {
    cursor: pointer;
    width: 30px;
    height: 30px;
  }

  .fullwidth-box-detail {
    overflow-y: auto;
    position: relative;
  }

  /* Màn hình thấp (laptop nhỏ, 13 inch) */
  @media (max-height: 768px) {
    .fullwidth-box-detail {
      height: calc(100vh - 360px);
    }
  }

  /* Màn hình trung bình */
  @media (min-height: 769px) and (max-height: 900px) {
    .fullwidth-box-detail {
      height: calc(100vh - 435px);
    }
    .box-width-is-rep {
      height: calc(100vh - 515px) !important;
    }
  }

  /* Màn hình lớn */
  @media (min-height: 901px) {
    .fullwidth-box-detail {
      height: calc(100vh - 465px);
    }
    .box-width-is-rep {
      height: calc(100vh - 545px) !important;
    }
  }
  .fullwidth-box-detail-popup {
    height: 365px !important;
  }

  .fullwidth-box-detail::-webkit-scrollbar {
    width: 8px;
  }

  .fullwidth-box-detail::-webkit-scrollbar-track {
    border: none;
    background: transparent;
  }
  .content-end {
    justify-content: end;
  }
  .bg-customer {
    background: #0688ee;
    color: #ffffff;
  }
  .bg-user {
    background: #ebebeb
  }
  .textType1 {
    white-space: pre-line; /* Giữ lại dấu xuống dòng trong tin nhắn */
    word-wrap: break-word;  /* Đảm bảo dòng dài không bị tràn */
    margin: 0;
    line-height: 20px;
    word-break: break-word;
  }


  /*// rep từng tin nhắn*/
  .boxRep {
    margin: 0 46px;
    padding: 10px;
    border: 1px solid #DCDFE6;
    border-bottom: none;
    border-radius: 4px;
    width: 350px;
  }
  .head-rep {
    font-weight: 600;
    color: #1d60a6;
    padding-bottom: 10px;
  }
  .content-rep {
    padding-bottom: 10px;
  }
  .truncate-text {
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .box-mess-rep {
    padding: 8px;
    margin-bottom: 6px;
    border-left: 5px solid #00D0FF;
    border-radius: 8px;
    background: #ffffff;
    color: #1d60a6;
  }

  .rep-bottom {
    position: absolute;
    bottom: 0;
    width: 95%;
  }
  .box-width-is-rep {
    height: calc(100vh - 420px);
  }
  .box-width-is-rep-popup {
    height: 288px !important;
  }
  .menu-chat span:hover {
    color: #1d60a6;
    font-weight: 700;
  }
  .time-style {
    color: #989898;
    font-size: 12px;
  }
  .bg-customer .time-style  {
    color: burlywood !important;
  }
  .date-separator {
    text-align: center;
    margin: 14px 0;
    font-size: 12px;
    color: #888;
    position: relative;
  }

  .date-separator::before,
  .date-separator::after {
    content: "";
    display: inline-block;
    width: 30%;
    height: 1px;
    background: #e5e5e5;
    vertical-align: middle;
    margin: 0 8px;
  }

</style>
<style>
  .pop-rep {
    min-width: 90px !important;
    font-size: 12px;
  }
  .pop-rep-none {
    display: none !important;
  }


  .input-chat {
    width: 100%;
    margin: 0 10px;
  }

  .input-chat textarea {
    /*border-radius: 20px;
    border: 1px solid #F0EFEF;*/
    border: none;
  }
  .file-upload-send .el-dialog__body {
    padding: 10px 20px !important;
  }
  .inputCaption input {
    border-top: none;
    border-left: none;
    border-right: none;
  }
  .txtL {
    text-align: left;
  }
  .txtR {
    text-align: right;
  }
  .bgX {
    background: #E8F3FF;
  }
  .bgX textarea {
    background: #E8F3FF;
  }
  .pd10 {
    padding: 10px !important;
  }
  .ml10 {
    margin-left: 10px;
  }
  .mImage img {
    object-fit: cover;
  }
  .mBg {
    background: rgb(12, 145, 223);
    color: rgb(255, 255, 255);
    padding: 5px;
    border-radius: 5px;
    font-size: 11px;
    max-width: 130px;
    text-align: center;
  }
  .text-right {
    text-align: right;
  }
</style>
